<template>
  <div class="item-container">
    <div
      :id="`itemexpander-${item.jsonid}`"
      :ref="`itemexpander-${item.jsonid}`"
      class="item-main"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
    >
      <div class="item-title">
        <i class="icon-transfer glyph-lg mr-3" />
        <span>{{ item.jsontype.toUpperCase() }}</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>{{ item.cityfrom }} - {{ item.cityto }}</h6>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>{{ item.request2 }}</h6>
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div v-if="dropdown" class="item-dropdown">
      <div class="item-dropdown-main">
        <ul>
            <li
              v-for="expanderItem in item.expanderItems"
              :key="expanderItem.title"
            >
              <h4>{{ expanderItem.title }}</h4>
              <p>{{ expanderItem.notes }}</p>
            </li>
          </ul>

        <div class="extra-info">
          <ExtraInfoButtons :item="item" itemtype="transfer" />
        </div>
      </div>
      <div v-if="item.fnotes && item.fnotes[0]" class="extra-info-notes">
        <h4>Notes</h4>
        <ul>
          <li v-for="(fnote, index) in item.fnotes" :key="index">
            {{ fnote }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ExtraInfoButtons from "@/partials/extra-info-buttons";

export default {
  components: {
    ExtraInfoButtons,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
    };
  },
  computed: {
    ...mapGetters({
      bookingNumber: "booking/getBookingNumber",
    }),
  },
  mounted() {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
